export default "__VITE_ASSET__JJ4iHg2m__"